import styled from 'styled-components';

export const ImpersonateWrapper = styled.div`
  > div {
    height: calc(100vh - 5rem);
  }

  > .error_msg {
    height: auto;
    text-align: center;
    font-size: 1.4rem;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Impersonate/components/styles.js